import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { AuthService } from 'auth';

import { RouterModule } from '@angular/router';
import { RedeemBookingModal } from '../../../../modals/redeem-booking-modal/redeem-booking-modal';
import { ToastService } from '../../../../core/services/toast.service';
import { MealBooking } from '../../../../core/models/redeem-booking.models';
import { VendorProfileService } from '../../../../core/services/vendor-profile.service';
import { VendorMeDto } from '../../../../core/models/dashboard.models';

@Component({
  selector: 'app-side-bar',
  imports: [
    CommonModule,
    NzIconModule,
    NzDropdownModule,
    RouterOutlet,
    FormsModule,
    ReactiveFormsModule,
    NzModalModule,
    NzInputModule,
    NzSpaceModule,
    RouterModule,
    NzDrawerModule,
    NzButtonModule,
    RedeemBookingModal,
  ],
  templateUrl: './side-bar.html',
  styleUrl: './side-bar.scss',
  standalone: true,
})
export class SideBar implements OnInit {
  currentDate = new Date();
  vendorProfile: VendorMeDto | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
    private vendorProfileService: VendorProfileService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.vendorProfileService.getProfile().subscribe((profile) => {
      this.vendorProfile = profile;
      this.cdr.detectChanges();
    });
  }

  get roleLabel(): string {
    const organizationName = this.vendorProfile?.organizationName?.trim();
    if (organizationName) {
      return organizationName;
    }

    const role = this.authService.role();
    if (!role) {
      return 'Vendor';
    }
    return Array.isArray(role) ? role[0] : role;
  }

  get userName(): string {
    const businessName = this.vendorProfile?.businessName?.trim();
    if (businessName) {
      return businessName;
    }

    const userInfo = this.authService.accessTokenInfo();
    return userInfo?.fullName || 'User';
  }

  get userInitials(): string {
    const name = this.userName;
    if (!name || name === 'User') {
      return '';
    }

    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }

    return name.slice(0, 2).toUpperCase();
  }

  isLogoutModalVisible = false;

  logout() {
    this.isLogoutModalVisible = true;
  }

  confirmLogout() {
    this.isLogoutModalVisible = false;
    this.vendorProfileService.clear();
    this.authService.logout();
  }

  isLoading = false;

  isOpen = false;
  isMobileMenuOpen = false;
  isRedeemModalOpen = false;

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  isMobileNavActive(path: string): boolean {
    return this.router.url === path || this.router.url.startsWith(`${path}/`);
  }

  openRedeemModal(): void {
    this.isRedeemModalOpen = true;
  }

  closeRedeemModal(): void {
    this.isRedeemModalOpen = false;
  }

  onBookingRedeemed(booking: MealBooking): void {
    this.toastService.success(`Booking redeemed for ${booking.staffName}.`);
    this.isRedeemModalOpen = false;
  }
}
